import type {
  CurrentValue,
  DomainGuid,
  ShortCircuitFaultTypes as ShortCircuitFaultType,
  ShortCircuitScenarioResults
} from '../../..';
import { AttentionStatusStorage2 } from '../../../evaluation/AttentionStatusRepository';
import type { ForRuleProviding } from '../../../evaluation/RulesProvider';
import { FaultCurrentEvaluationEngine } from '../../../evaluation/shortCircuit/engines/mediumVoltage/faultCurrentEvaluationEngine';
import { evaluateBusbars } from '../../../evaluation/shortCircuit/summary/evaluateBusbars';
import { evaluateEnergyConsumers } from '../../../evaluation/shortCircuit/summary/evaluateEnergyConsumers';
import type { FunctionalGrid } from '../../../grid/FunctionalGrid';
import type { MvShortCircuitSummaryEvaluatedResults } from './MvShortCircuitSummaryEvaluatedResults';

type GetMvShortCircuitSummary = (
  allScenarios: ShortCircuitScenarioResults[],
  rulesProvider: ForRuleProviding,
  functionalGrid: FunctionalGrid
) => MvShortCircuitSummaryEvaluatedResults;

export type ShortCircuitCalculation = {
  faultType: ShortCircuitFaultType;
  gridElements: {
    id: DomainGuid;
    result: CurrentValue;
  }[];
};

export const getMvShortCircuitSummary: GetMvShortCircuitSummary = (
  allScenarios,
  rulesProvider,
  functionalGrid
) => {
  const evaluationEngine = new FaultCurrentEvaluationEngine(
    AttentionStatusStorage2.noStorage(),
    rulesProvider
  );
  return {
    energyConsumers: evaluateEnergyConsumers(allScenarios, evaluationEngine),
    mvBusbars: evaluateBusbars(allScenarios, evaluationEngine, functionalGrid)
  };
};
